// extracted by mini-css-extract-plugin
module.exports = {"error":"OIDCCallbackError_error__3LFhC","header":"OIDCCallbackError_header__1w_W5","body":"OIDCCallbackError_body__3O1jE","link":"OIDCCallbackError_link__1rkTc"};